import {getAnalyticsSessionId} from "@pg-mono/algolytics";
import {sessionCache} from "@pg-rp/session-cache";

import {FALLBACK_SESSION_ID_SESSION_STORAGE_KEY} from "./offer_listing_amplitude_item_list_storage_keys";

export const getClientAnalyticsSessionId = (): string | null => {
    const analyticsSessionId = getBrowserAnalyticsSessionId();

    if (analyticsSessionId) {
        return analyticsSessionId;
    }

    return getFallbackSessionId();
};

const getBrowserAnalyticsSessionId = (): string | null => {
    if (typeof document === "undefined") {
        return null;
    }

    return getAnalyticsSessionId() ?? null;
};

const getFallbackSessionId = (): string | null => {
    const existingId = sessionCache.get<string>(FALLBACK_SESSION_ID_SESSION_STORAGE_KEY);

    if (existingId) {
        return existingId;
    }

    const nextId = `fallback-${Date.now()}-${Math.random().toString(16).slice(2)}`;
    sessionCache.set(FALLBACK_SESSION_ID_SESSION_STORAGE_KEY, nextId);

    return nextId;
};
import {getAnalyticsSessionId} from "@pg-mono/algolytics";
import {sessionCache} from "@pg-rp/session-cache";

import {FALLBACK_SESSION_ID_SESSION_STORAGE_KEY} from "./offer_listing_amplitude_item_list_storage_keys";

export const getClientAnalyticsSessionId = (): string | null => {
    const analyticsSessionId = getBrowserAnalyticsSessionId();

    if (analyticsSessionId) {
        return analyticsSessionId;
    }

    return getFallbackSessionId();
};

const getBrowserAnalyticsSessionId = (): string | null => {
    if (typeof document === "undefined") {
        return null;
    }

    return getAnalyticsSessionId() ?? null;
};

const getFallbackSessionId = (): string | null => {
    const existingId = sessionCache.get<string>(FALLBACK_SESSION_ID_SESSION_STORAGE_KEY);

    if (existingId) {
        return existingId;
    }

    const nextId = `fallback-${Date.now()}-${Math.random().toString(16).slice(2)}`;
    sessionCache.set(FALLBACK_SESSION_ID_SESSION_STORAGE_KEY, nextId);

    return nextId;
};
